import React, {Component} from 'react';
import {FaIcon} from "../FaIcon";


export class TableOrderButton extends Component {
    render() {
        const activeClass = this.props.isActive ? 'active' : '';
        const directionClass = this.props.direction;

        return (
            <button className={`table-order-button ${activeClass} ${directionClass}`}>
                <FaIcon iconName="caret-down"/>
            </button>
        )
    }
}